<template>
  <div class="App-Reset-Succ" txt-center>
    <div txt-center>
      <el-image lazy m-t-1q :style="`width: 230px;`" :src="img"></el-image>
    </div>
    <h2 f-w-600 m-tb-0 txt-center>
      Hmm... this password reset link isn't valid
    </h2>
    <p txt-center m-tb-0>
      The link might have expired or <br />
      been used already.
    </p>
    <p m-tb-0>
      <router-link to="/forgot">
        <el-link type="primary">Request a new reset link </el-link>
      </router-link>
    </p>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import img from "@/assets/illustrations/key-invalid.svg";

// import CheckEmailImage
@Options({
  components: {},
})
export default class extends Vue {
  img = img;
}
</script>

<style lang="scss">
.App-Reset-Succ {
  .el-image {
    padding: 20px;
  }
}
</style>
